import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Header,
  TransactionMessage,
  PricingCards,
  CodeActivation,
  FreeButton,
  TokenUsageGuidea,
  Footer,
} from "./components";
import { useAuthContext } from "@context/useAuthStore";
import Axios from "@/services/axios";

import { ScrollArea } from "@components/ui/scroll-area";

const SubscriptionPage = () => {
  const navigate = useNavigate();
  const { refetchSubscription } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [transactionId, setTransactionId] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [error, setError] = useState("");

  const PADDLE_CLIENT_TOKEN = process.env.REACT_APP_PADDLE_CLIENT_TOKEN;

  const verifySubscription = useCallback(
    async (event) => {
      try {
        setIsLoading(true);
        setStatusMessage("Verifying your subscription...");
        const data = event.data;
        await Axios.post("/user/subscription/verify", data);
        await refetchSubscription();
        navigate("/home");
      } catch (error) {
        console.error(error);
        setError("Subscription verification failed. Please contact support.");
      } finally {
        setIsLoading(false);
        setStatusMessage("");
      }
    },
    [navigate, refetchSubscription]
  );

  useEffect(() => {
    if (window.Paddle && PADDLE_CLIENT_TOKEN) {
      if (PADDLE_CLIENT_TOKEN.startsWith("test_"))
        window.Paddle.Environment.set("sandbox");
      window.Paddle.Initialize({
        token: PADDLE_CLIENT_TOKEN,
        eventCallback: function (event) {
          setTransactionId(event?.data?.transaction_id);
          if (event?.name === "checkout.completed") {
            verifySubscription(event);
          }
        },
      });
    }
  }, [PADDLE_CLIENT_TOKEN, verifySubscription]);

  if (isLoading) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center h-screen gap-4">
        <div className="w-12 h-12 border-4 border-t-transparent border-teal-500 dark:border-teal-400 rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <ScrollArea className="h-full w-full">
      <div className="max-w-6xl mx-auto p-6 space-y-6 pb-12">
        <Header />
        <TransactionMessage
          statusMessage={statusMessage}
          transactionId={transactionId}
          error={error}
        />
        <FreeButton setIsLoading={setIsLoading} />
        <PricingCards />
        <CodeActivation setIsLoading={setIsLoading} />
        <TokenUsageGuidea />
        <Footer />
      </div>
    </ScrollArea>
  );
};

export default SubscriptionPage;
